/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gYEVvAzCcLMHDVPvuYxkFh

import {
  createStyleTokensProvider,
  createUseStyleTokens,
} from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: gYEVvAzCcLMHDVPvuYxkFh/projectModule

import projectcss from "./plasmic_plasmic_kit_styles_pane.module.css"; // plasmic-import: gYEVvAzCcLMHDVPvuYxkFh/projectcss

const data = {
  base: projectcss.plasmic_tokens,
  varianted: [],
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);

export const StyleTokensProvider = createStyleTokensProvider(
  data,
  _useGlobalVariants
);
